/**
 * scenarioEnvironment.js v1.0.0 - 2026-10-09
 *
 * Single reader of the terrain and weather the planner chose in Tab 2.
 *
 * CALC-011: Tab 2 saves terrain/weather/threat under
 * scenario.operation_parameters.environmental_factors (APP_RULES Rule 15). The calculator used to
 * read scenario.environment.*, an object no tab writes, so the planner's terrain and weather never
 * reached the casualty calculation (it always used MIXED / a non-key weather). This resolver reads
 * the owner field first, then the legacy scenario.environment (older saved scenarios and test
 * fixtures), then the documented default, and reports which values were defaulted.
 *
 * Keys are validated against operationsConfig TERRAIN_TYPES / WEATHER_CONDITIONS, the same
 * constants Tab 2's selectors are built from. An unknown key is a data error and throws
 * (APP_RULES Rule 6.1).
 *
 * Version history:
 *   v1.0.0 (2026-10-09): initial release
 */
import {
  TERRAIN_TYPES,
  WEATHER_CONDITIONS,
  DEFAULT_ENVIRONMENT
} from '../constants/operationsConfig.js';

const FIELDS = {
  terrain: TERRAIN_TYPES,
  weather: WEATHER_CONDITIONS
};

/**
 * @param {Object} scenario
 * @returns {{terrain: string, weather: string, defaulted: {terrain: boolean, weather: boolean}}}
 */
export function resolveScenarioEnvironment(scenario) {
  const factors = scenario?.operation_parameters?.environmental_factors;
  const legacy = scenario?.environment;
  const resolved = { defaulted: {} };

  Object.entries(FIELDS).forEach(([field, validSet]) => {
    const value = factors?.[field] ?? legacy?.[field];
    if (value === undefined || value === null || value === '') {
      resolved[field] = DEFAULT_ENVIRONMENT[field];
      resolved.defaulted[field] = true;
      return;
    }
    if (!Object.prototype.hasOwnProperty.call(validSet, value)) {
      throw new Error(
        `resolveScenarioEnvironment: unknown ${field} '${value}' ` +
        `(valid: ${Object.keys(validSet).join(', ')}). ` +
        `Path: scenario.operation_parameters.environmental_factors.${field} (set in Tab 2)`
      );
    }
    resolved[field] = value;
    resolved.defaulted[field] = false;
  });

  return resolved;
}
